import { memo } from 'react';

import Link from 'next/link';

const Careers = memo(() => (
  <div className='d-md-flex'>
    <div className='mb-md-0 mb-5 col-md-6 px-0'>
      <div className='medium black font-16px mb-md-3 mb-2'>Careers</div>
      <div className='gray'>
        <Link href='/careers'>
          <a className='font-14px gray'>Job Openings</a>
        </Link>
      </div>
    </div>
    <div className='mb-md-0 mb-5 col-md-6 px-0'>
      <div className='medium black font-16px mb-md-3 mb-2'>For Business</div>
      <div className=''>
        <a className='gray font-14px' href={`${process.env.CLIENT_WEB_URL}`} rel='noopener noreferrer' target='_blank'>
          Contact Us
        </a>
      </div>
    </div>
  </div>
));

Careers.displayName = 'Careers';

export default Careers;
